export default __webpack_public_path__ + "static/media/ZoneTypeH.74a13124.png";